<template>
    <div class="contain desFile">
        <!-- <div class="header-box">
            文件夹
        </div> -->
        <div class="header-box">
            <el-page-header @back="goBack" :content="pageTitle"></el-page-header>
            <el-button type="primary" @click="addFormVisible=true">添加文件夹</el-button>
        </div>
        <div class="box">
            <!-- <div class="build-bar">
                <el-button v-for="item in bars" :key="item.id" style="margin:5px 10px;" :class="cuid==item.id?'primary':''" @click="setCuid(item)">{{item.name}}</el-button>
            </div> -->
            <div class="box-content flex-wrap">
                <div class="table-item" style="height:100%;">
                    <!-- <div style="width:150px;" class="item-con">
                        招标申报材料
                    </div> -->
                    <div style="flex:1;display:flex;flex-wrap: wrap;height: 220px;" class="item-con">
                        <div style="width:150px;display:flex;flex-wrap:wrap;align-content: flex-start;" v-for="child in dataList" :key="child.id">
                            <p v-if="child.fileType!='0'" class="title nowrap" style="width:100%;" :title="child.attachmentName">{{child.attachmentName}}</p>
                            <p  style="width:100%;">
                                <img v-if="child.fileType=='0'" style="width:100px;height:100px;" src="../../../assets/image/file.png" @click="showChild(child.id)" />
                                <img v-if="child.fileType=='1'" style="width:50px;height:50px;" src="../../../assets/image/office/word.png" @click="showFile(child.attachment,child.attachmentName)" />
                                <img v-else-if="child.fileType=='2'" style="width:50px;height:50px;" src="../../../assets/image/office/excel.png" @click="showFile(child.attachment,child.attachmentName)" />
                                <img v-else-if="child.fileType=='3'" style="width:50px;height:50px;" src="../../../assets/image/office/pdf.png" @click="showFile(child.attachment,child.attachmentName)" />
                                <img v-else-if="child.fileType=='4'" style="width:50px;height:50px;" src="../../../assets/image/office/photo.png" @click="showFile(child.attachment,child.attachmentName)" />
                                <img v-else-if="child.fileType=='5'" style="width:50px;height:50px;" src="../../../assets/image/office/undefined.png" @click="showFile(child.attachment,child.attachmentName)" />
                            </p>
                            <p v-if="child.fileType!='0'" style="width:100%;"><img style="width:40px;height:40px;" src="../../../assets/image/downfile.png" @click="downFile(child.attachment)" /></p>
                            <p v-if="child.fileType=='0'" class="name nowrap" style="width:100%;">{{child.folderName}}</p>
                            <p v-if="child.fileType!='0'" class="name" style="width:100%;">{{child.userName}}上传</p>
                            <p v-if="child.fileType!='0'" class="time" style="width:100%;">{{child.createDate}}</p>
                        </div>
                        <div style="width:150px;display:flex;flex-wrap:wrap;align-content: flex-start;justify-content: center;align-items: center;padding-top: 45px;">
                            <el-upload
                              class="upload-demo"
                              v-bind:action="uploadUrl"
                              :headers="uploadHead"
                              :data={type:213}
                              :show-file-list="false"
                              :on-success="fileSuccess1">
                                <el-button size="small" class="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 新增窗口 -->
            <el-dialog
                title="添加文件夹"
                width="500px"
                :visible.sync="addFormVisible"
                center
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
            >
                <el-form :model="addForm" ref="addForm" label-width="100px" :label-position="labelPosition">
                    <el-form-item label="文件名：">
                        <el-input v-model="addForm.folderName" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddRow">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import PDF from 'pdfjs-dist'
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
    data(){
        return{
            pageTitle:'',
            groupId:"",
            bars:[],
            cuid:'',
            curFile:{
                type:'',
                materiaType:'',
                groupId:'',
                entProjectId:'',
                attachment:'',
                attachmentName:'',
                attachmentType:'',
                userId:'',
                userName:'',
            },
            uploadUrl:base.url+"/upload/uploadPhoto",//上传地址
            uploadHead:{  //上传接口header
                accessToken:this.$store.state.token
            },
            entProjectId:'',
            dataList:[],
            pages: [],
            pdfDoc: null,
            addFormVisible:false,
            addForm:{
                folderName:""
            },
            labelPosition:'right',
            wordUrl:'',//word文档地址
            nodeName:[],
            attachmentType:'',
            type:'',
            materiaType:'',
            // baseNum:0,
        }
    },
    mounted() {
        this.groupId = this.$store.state.groupId;
        if(''==this.groupId){
            this.$store.commit('setGroupId');
            this.groupId = this.$store.state.groupId;
        }
        this.attachmentType = this.$route.params.state
        this.type = this.$route.params.type
        this.cuid = this.type
        this.materiaType = this.$route.params.mater
        this.entProjectId = this.$route.params.id=='0'?undefined:this.$route.params.id
        if(this.isExitList(this.cuid,base.company)){
            this.bars = base.company
            this.nodeName = base.companyNode
        }else if(this.isExitList(this.cuid,base.join)){
            this.bars = base.join
            this.nodeName = base.joinNode
        }else if(this.isExitList(this.cuid,base.serve)){
            this.bars = base.serve
            this.nodeName = base.serveNode
        }else if(this.isExitList(this.cuid,base.sale)){
            this.bars = base.sale
            this.nodeName = base.saleNode
        }
        this.showPageTitle()
        this.getData()
    },
    methods:{
        //获取数据
        getData(){
            var that = this
            myHttp.getAttachmentByModel({
                id:'',
                attachmentType:this.attachmentType,
                type:this.type,
                groupId:this.groupId,
                materiaType:this.materiaType
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.entity||[]
                    for(var j=0;j<list.length;j++){
                        list[j].fileType = list[j].attachment&&''!=list[j].attachment?that.getImg(list[j].attachment):'0'
                    }
                    that.dataList = list
                    //that.getDataByType(resp.data.data)
                }
            })
        },

        //判断是否在list其中
        isExitList(id,list){
            var result = false
            for(var i=0;i<list.length;i++){
                if(id==list[i].id){
                    result = true
                }
            }
            return result
        },

        //获取当前序列
        getIndex(id){
            var list = this.bars
            var index = 0
            for(var i=0;i<list.length;i++){
                if(id==list[i].id){
                    index = list[i].index
                }
            }
            return index;
        },

        //根据type展示数据
        getDataByType(data){
            var dataList = [];
            var nodeCode = this.nodeName
            var index = this.getIndex(this.cuid)
            var str = nodeCode[index]
            for(var i=0;i<str.length;i++){
                var list = data[str[i].val]||[]
                var obj = {}
                if(list.length==0){
                    obj = {
                        attachments:[],
                        materiaType:str[i].id
                    }
                }else{
                    obj = list[0]
                    var li = obj.attachments||[]
                    for(var j=0;j<obj.attachments.length;j++){
                        obj.attachments[j].fileType = this.getImg(obj.attachments[j].attachment)
                    }
                }
                obj.name = this.getNameByType(obj.materiaType)
                dataList.push(obj)
            }
            this.dataList = dataList
            // console.log(dataList)
        },

        //获取节点名称
        getNameByType(type){
            var result = ''
            var index = this.getIndex(this.cuid)
            var list = this.nodeName[index]
            for(var i=0;i<list.length;i++){
                if(list[i].id==type){
                    result = list[i].name
                }
            }
            return result
        },

        //展示页面名称
        showPageTitle(){
            var typeName = ''
            var metarName = ''
            var attachName = ''
            for(var i=0;i<this.bars.length;i++){
                if(this.bars[i].id==this.type){
                    typeName = this.bars[i].name+' - '
                }
            }
            var index = this.getIndex(this.cuid)
            var list = this.nodeName[index]||[]
            for(var i=0;i<list.length;i++){
                if(list[i].id==this.materiaType && ''!=list[i].name){
                    metarName = list[i].name+' - '
                }
            }

            if(this.attachmentType=='1'){
                attachName = '模板文档'
            }else if(this.attachmentType=='2'){
                attachName = '原件文档'
            }

            this.pageTitle = typeName+metarName+attachName
        },
        //获取图片
        getImg(url){
            // 1:word   2:excel    3:pdf     4:img   5:undefined
            var result = '';
            var list = url.split('.')
            var str = list[list.length-1]
            if(base.docType.indexOf(str)>=0){
                result = '1'
            }else if(base.imgType.indexOf(str)>=0){
                result = '4'
            }else if(base.excelType.indexOf(str)>=0){
                result = '2'
            }else if(base.pdfType.indexOf(str)>=0){
                result = '3'
            }else{
                result = '5'
            }
            return result
        },
        //导出
        // exportOut(){
        //     var token = this.$store.state.token;
        //     window.open(myHttp.getExportInspectsByGroupId+'?groupId='+this.groupId+'&unit='+this.search.unit+'&date='+this.search.date+'&accessToken='+token)
        // },
        //查看
        handleEdit(index,row){
            // this.$router.push('/checkDetail/'+row.id+'/'+row.type)
        },
        
        //展示
        setCuid(row){
            this.cuid = row.id
            this.getData()
        },
        //返回
        goBack(){
            this.$router.go(-1);
        },
        /**申报材料 */
        //上传成功
        fileSuccess1(res,file){
            if(res.code==200){
                this.curFile.type = this.cuid
                this.curFile.materiaType = this.materiaType
                this.curFile.groupId = this.groupId
                this.curFile.entProjectId = this.entProjectId
                this.curFile.attachment = res.data.saveUrls
                var name = file.name.split('.')
                name.pop()
                name = name.join();
                this.curFile.attachmentName = name
                this.curFile.userId = this.$store.state.user.id
                this.curFile.userName = this.$store.state.user.name
                this.curFile.attachmentType = this.attachmentType
                this.curFile.parentId = ''
                this.submitFun(this.curFile)
                
            }else{
                this.$message.error(resp.msg);
            }
            
        },

        /**
         * 添加方法
         */
        submitFun(data){
            let that = this
            // window.open(base.fileView+'/addTask?url='+base.httpCtx+data.attachment);
            myHttp.postAttachment(data).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message({type: 'success',message: '文件添加成功!'});
                    that.getData()
                }else{
                    that.$message.error(resp.data.msg);
                }
            })
        },
        //查看文档
        showFile(url,name){
            var that = this
            window.open(base.fileView+'/onlinePreview?url='+encodeURIComponent(base.httpCtx+url),"_blank");
            
        },

        //查看文档下面的文件
        showChild(id){
            this.$router.push('/desModel/'+this.cuid+'/'+this.materiaType+'/'+this.attachmentType+'/'+this.entProjectId+'/'+id)
            // this.$router.push('/desFileModel/'+id)
        },
        
        //下载文档
        downFile(url){
            window.open(base.httpCtx+url)
        },
        //查看模板
        // showModel(id,type){
        //     if(id==''||undefined==id)return;
        //     var that = this
        //     myHttp.getAttachmentByModel({
        //         id:id,
        //         attachmentType:1
        //     }).then(function(resp){
        //         if(resp.data.code=='200'){
        //             var list = resp.data.data.entity||[]
        //             if(type==1){
        //                 that.dataList1[0].attachments = list
        //             }else if(type==2){
        //                 that.dataList2[0].attachments = list
        //             }else if(type==3){
        //                 that.dataList3[0].attachments = list
        //             }else if(type==4){
        //                 that.dataList4[0].attachments = list
        //             }else if(type==5){
        //                 that.dataList5[0].attachments = list
        //             }
        //         }
        //     })
        // },
        //查看原件
        // showWord(id,type){
        //     if(id==''||undefined==id)return;
        //     var that = this
        //     myHttp.getAttachmentByModel({
        //         id:id,
        //         attachmentType:2
        //     }).then(function(resp){
        //         if(resp.data.code=='200'){
        //             var list = resp.data.data.entity||[]
        //             if(type==1){
        //                 that.dataList1[0].attachments = list
        //             }else if(type==2){
        //                 that.dataList2[0].attachments = list
        //             }else if(type==3){
        //                 that.dataList3[0].attachments = list
        //             }else if(type==4){
        //                 that.dataList4[0].attachments = list
        //             }else if(type==5){
        //                 that.dataList5[0].attachments = list
        //             }
        //         }
        //     })
        // },

        //添加文件夹
        sumbitAddRow(){
            var that = this
            if(this.addForm.folderName==''){
                this.$message.error('请输入文件名称');
                return
            }
            this.addForm.type = this.cuid
            this.addForm.materiaType = this.materiaType
            this.addForm.groupId = this.groupId
            this.addForm.entProjectId = this.entProjectId
            this.addForm.parentId = ''
            this.addForm.attachmentType = this.attachmentType
            this.addForm.userId = util.session.get('user').id
            this.addForm.userName = util.session.get('user').name
            myHttp.postAttachment(this.addForm).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    that.$message.success('添加成功');
                    that.addFormVisible = false
                    that.getData()
                }else{
                    that.$message.error(resp.data.msg);
                }
            })
        },

    }
}
</script>
<style scoped>
    .contain{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header-box{
        padding: 15px 20px;
        height: 70px;
        width: 100%;
        box-shadow: 1px 2px 3px 2px #ddd;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        text-align: left;
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #2058D9;
        justify-content: space-between;
        justify-items: space-between;
    }
    .box{
        margin-top: 15px;
        width: 100%;
        height: calc( 100% - 70px );
    }
    .box-content{
        width: 100%;
        height: calc( 100% - 20px );
        background: #fff;
        overflow: auto;
        display: flex;
        align-content: flex-start;
    }
    .build-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 80px;
        background: #fff;
        border-bottom: 3px solid #17b2fe;
        padding: 0 20px;
    }
    .box-content .el-button{
        background: #FFF;
        border: 1px solid #DCDFE6;
        color: #606266;
    }
    .primary{
        background-color: #17b2fe;
        border-color: #17b2fe;
        color: #fff;
    }
    .table-item{
        width: 100%;
        min-height: 50px;
        display: flex;
        border-bottom: 15px solid #ecf0f5;
        background: #fff;
    }
    .flex-wrap{
        display: flex;
        flex-wrap: wrap;
    }
    .item-con{
        padding: 10px;
    }
    .item-con p{
        margin: 0;
        margin-bottom: 15px;
        width: 100%;
        text-align: center;
        font-size: 14px;
    }
    .item-con img{
        cursor: pointer;
    }
    .table-item-sec{
        width: 100%;
        height: 50px;
        background: #17B2FE;
        color: #fff;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 15px solid #ecf0f5;
    }
    .nowrap {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
</style>
<style>
    .build-bar span{
        margin-left: 0;
    }
    .el-table td, .el-table th{
        text-align: center;
    }
    /* .el-dialog{
        width: 500px;
    } */
</style>